<template>
  <div>
    <v-tooltip
      top
      content-class="light-tooltip"
    >
      <template #activator="{ on, attrs }">
        <div
          class="text-center container-info"
          :class="{
            'is_current' : cycle.is_current
          }"
          v-bind="attrs"
          v-on="on"
        >
          <span
            class="rounded-circle d-inline-block d-flex justify-content-center align-items-center border info-text"
            :class="{
              'gray--border' : !cycle.is_current,
            }"
            style="width: 33px; height: 33px; cursor: pointer;"
          >
            <p class="text-center text-sm font-weight-bold p-0 m-0 font-9">
              -
            </p>
          </span>
          <p class="text-center sub-text font-9 m-0">
            M{{ moduleOrder }}
          </p>
        </div>
      </template>
      <p class="text-center m-0 font-11">
        {{ cycle.started ? 'Você não escolheu os módulos do ciclo' : 'Este ciclo de estudos ainda não está disponível' }}
      </p>
    </v-tooltip>
  </div>    
</template>
<script>
export default {
    props: {
        cycle: {
            type:Object,
            required:true,
        },
        moduleOrder: {
          required:true,
          type: Number,
        },
    }
}
</script>
<style lang="scss">

</style>